import { render, staticRenderFns } from "./dianshi.vue?vue&type=template&id=9f87de9a&scoped=true&"
import script from "./dianshi.vue?vue&type=script&lang=ts&"
export * from "./dianshi.vue?vue&type=script&lang=ts&"
import style0 from "./dianshi.vue?vue&type=style&index=0&id=9f87de9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f87de9a",
  null
  
)

export default component.exports